import {environment} from '@environments/environment';
import {Config} from '@auth/types';

export const CONFIG: Config = {
  APP_NAME: environment.APP_NAME,
  TTL_AUTH: environment.TTL_AUTH,
}
